<template>
  <div class="card payment-thermal-document" style="border: none">
    <div
      class="card-body"
      :style="isPrint ? `height: ${height}; width: ${width};` : ''"
    >
      <div class="row justify-content-between align-items-center">
        <div class="col-md-12 text-center">
          <ImageComponent place="logo-invoice"></ImageComponent>
          <div class="font-weight-light" style="font-size: 8.5pt">
            {{ setting.clinic_address }}
          </div>
          <div class="font-weight-light" style="font-size: 8.5pt">
            {{ setting.phone }}
          </div>
          <div
            :class="[
              'thermal-status',
              'tone-' + (data.document_status_tone || 'danger'),
            ]"
          >
            {{ data.document_status_label || "BELUM DIBAYAR" }}
          </div>
          <div v-if="data.is_copy" class="thermal-copy">*** SALINAN ***</div>
        </div>

        <div class="col-12">
          <!-- <span>====================</span> -->
          <div
            class="my-2 w-100 text-muted"
            style="border-top: 2px dashed"
          ></div>
          <table style="font-size: 8.5pt !important">
            <tr>
              <td style="width: 100px">Nomor</td>
              <td style="width: 9px">:</td>
              <td>{{ data.invoice_number || data.id }}</td>
            </tr>
            <tr>
              <td>Tanggal</td>
              <td style="width: 9px">:</td>
              <td>{{ data.display_created_at }}</td>
            </tr>
            <tr>
              <td>Nama Pasien</td>
              <td style="width: 9px">:</td>
              <td>{{ data.patient_name }}</td>
            </tr>
            <tr v-if="data.sub_patient_id != null">
              <td>Nama Sub Pasien</td>
              <td style="width: 9px">:</td>
              <td>{{ data.sub_patient_name }}</td>
            </tr>
            <tr>
              <td>Nomor HP</td>
              <td style="width: 9px">:</td>
              <td>{{ data.patient_mobile_phone }}</td>
            </tr>
            <tr>
              <td>Dokter</td>
              <td style="width: 9px">:</td>
              <td>{{ data.doctor_name }}</td>
            </tr>
          </table>
        </div>
      </div>
      <!-- <span>====================</span> -->
      <div class="my-2 w-100 text-muted" style="border-top: 2px dashed"></div>
      <div style="font-size: 8.5pt">
        <div class="row thermal-items">
          <!-- item -->
          <div
            class="col-md-12 thermal-line-item"
            v-for="(data, index) in items"
            :key="index"
          >
            <span class="thermal-line-item__name">{{ data.name }}</span>
            <div class="thermal-line-item__calculation">
              <span
                >{{ data.quantity }} x
                {{
                  parseInt(
                    data.price - data.promo_amount + data.discount_amount
                  ).toLocaleString("id-ID")
                }}</span
              >
              <span>
                {{
                  parseInt(
                    (data.price - data.promo_amount + data.discount_amount) *
                      data.quantity
                  ).toLocaleString("id-ID")
                }}
              </span>
            </div>
            <div
              class="thermal-line-item__discount"
              v-if="data.discount_amount != 0"
            >
              <span
                >Disc.
                {{
                  parseInt(data.discount_amount).toLocaleString("id-ID")
                }}</span
              >
            </div>
          </div>
        </div>
      </div>
      <!-- <div style="min-height: 285px; font-size: 7pt">
        <div class="row">
          <div class="col-md-12">
            <b-table borderless small :items="items" :fields="fields" style="font-size: 8pt !important">
              <template #table-colgroup="scope">
                <col v-for="field in scope.fields" :key="field.key" />
              </template>
              <template #cell(price)="data">
                {{
                  "Rp " +
                  parseInt(
                    parseInt(data.item.price) + data.item.discount_amount
                  ).toLocaleString("id-ID")
                }}
              </template>
              
              <template #cell(subtotal)="data">
                <span class="d-block">
                  {{
                    "Rp " +
                    parseInt(
                      data.item.price * data.item.quantity
                    ).toLocaleString("id-ID")
                  }}
                </span>
                <span class="d-block" v-if="data.item.discount_amount != 0"
                  >Disc : Rp
                  {{
                    `${parseInt(data.item.discount_amount).toLocaleString(
                      "id-ID"
                    )} ${
                      data.item.discount_type == 1 &&
                      (data.item.discount_amount != 0 ||
                        data.item.discount_percentage != 0)
                        ? `(${parseInt(data.item.discount_percentage)})%`
                        : ""
                    }`
                  }}</span
                >
              </template>
            </b-table>
          </div>
        </div>
      </div> -->
      <!-- <span>====================</span> -->
      <div class="thermal-divider"></div>
      <div class="thermal-notes">
        <strong>Catatan:</strong>
        <span>{{ data.notes || "-" }}</span>
      </div>
      <!-- <span>====================</span> -->
      <div class="thermal-divider"></div>
      <div class="thermal-summary">
        <div class="mr-2">
          <!-- Notes -->
          <!-- <div
            class="form-group"
          >
            <label for="notes">Catatan:</label>
            <textarea
              name=""
              id="notes"
              cols="30"
              rows="3"
              class="form-control"
              style="resize: none"
              v-model="data.notes"
              readonly
            ></textarea>
          </div> -->
        </div>
        <table v-if="showSummary" style="font-size: 8.5pt !important">
          <tr>
            <td style="width: 150px">Subtotal</td>
            <td class="font-weight-bold" style="width: 25px">Rp</td>
            <td class="text-right">
              <span class="font-weight-bold">{{
                parseInt(data.total_amount).toLocaleString("id-ID")
              }}</span>
            </td>
          </tr>
          <tr>
            <td>Diskon</td>
            <td class="font-weight-bold" style="width: 25px">Rp</td>
            <td class="text-right">
              <span class="font-weight-bold">{{
                parseInt(data.discount).toLocaleString("id-ID")
              }}</span>
            </td>
          </tr>
          <tr>
            <td>Biaya Tambahan</td>
            <td class="font-weight-bold" style="width: 25px">Rp</td>
            <td class="text-right">
              <span class="font-weight-bold">{{
                parseInt(data.surcharge).toLocaleString("id-ID")
              }}</span>
            </td>
          </tr>
          <tr v-if="data.coupon_amount">
            <td>Kupon</td>
            <td class="font-weight-bold" style="width: 25px">Rp</td>
            <td class="text-right">
              <span class="font-weight-bold">{{
                parseInt(data.coupon_amount).toLocaleString("id-ID")
              }}</span>
            </td>
          </tr>
          <tr>
            <td>Total</td>
            <td class="font-weight-bold" style="width: 25px">Rp</td>
            <td class="text-right">
              <span class="font-weight-bold">{{
                parseInt(data.final_amount).toLocaleString("id-ID")
              }}</span>
            </td>
          </tr>
          <tr v-if="numberValue(data.paid_amount) > 0">
            <td>Terbayar</td>
            <td class="font-weight-bold">Rp</td>
            <td class="text-right font-weight-bold">
              {{ numberValue(data.paid_amount).toLocaleString("id-ID") }}
            </td>
          </tr>
          <tr v-if="numberValue(data.refunded_amount) > 0">
            <td>Refund</td>
            <td class="font-weight-bold">Rp</td>
            <td class="text-right font-weight-bold">
              {{ numberValue(data.refunded_amount).toLocaleString("id-ID") }}
            </td>
          </tr>
          <tr v-if="numberValue(data.unpaid_amount) > 0">
            <td>Sisa</td>
            <td class="font-weight-bold">Rp</td>
            <td class="text-right font-weight-bold">
              {{ numberValue(data.unpaid_amount).toLocaleString("id-ID") }}
            </td>
          </tr>
        </table>
      </div>
      <div class="thermal-footer-meta">
        Dicetak {{ printTime }}<br /><span v-if="data.created_by_name"
          >Kasir: {{ data.created_by_name }}</span
        ><br /><span v-if="data.guarantee_reference"
          >Ref: {{ data.guarantee_reference }}</span
        >
      </div>
    </div>
    <!-- <div class="d-flex justify-content-center p-0 mt-n3">
      <div>
        <hr class="special-hr" style="margin: 2px" />
        <div>{{ currentUserPersonalInfo.name }}</div>
      </div>
    </div> -->
    <!-- <div class="d-flex justify-content-center p-0 mt-n3">
      <div>
        <hr class="special-hr" style="margin: 2px" />
        <div>{{ currentUserPersonalInfo.name }}</div>
      </div>
    </div> -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ImageComponent from "@/component/general/ImageComponent.vue";

export default {
  props: {
    data: Object,
    height: String,
    width: String,
    isPrint: Boolean,
    setting: Object,
    items: Array,
    renderNotes: Boolean,
    showSummary: Boolean,
    notes: String,
  },

  computed: {
    ...mapGetters(["currentUserPersonalInfo"]),
    printTime() {
      return new Date().toLocaleString("id-ID", {
        dateStyle: "short",
        timeStyle: "short",
      });
    },

    mutated_total_amount: {
      set(newValue) {
        this.data.total_amount = newValue;
      },
      get() {
        let amount = this.data.total_amount;
        this.items.forEach((value) => {
          amount += value.discount_amount * value.quantity;
        });
        return amount;
      },
    },

    mutated_final_amount: {
      set(newValue) {
        this.data.final_amount = newValue;
      },
      get() {
        let amount = this.data.final_amount;
        this.items.forEach((value) => {
          amount += value.discount_amount * value.quantity;
        });
        return amount;
      },
    },
  },

  components: {
    ImageComponent,
  },

  data() {
    return {
      // Table Head
      fields: [
        {
          key: "number",
          label: "#",
          sortable: true,
        },
        {
          key: "name",
          label: "Ket",
        },
        {
          key: "quantity",
          label: "Jml",
        },

        {
          key: "price",
          label: "Nett",
          thClass: "text-right",
          tdClass: "text-right",
        },
        {
          key: "subtotal",
          label: "Subtotal",
          thClass: "text-right",
          tdClass: "text-right",
        },
      ],
    };
  },

  mounted() {},
  methods: {
    numberValue(value) {
      const n = Number(value || 0);
      return Number.isFinite(n) ? n : 0;
    },
  },
};
</script>

<style scoped>
.special-hr {
  border-color: #000000;
  border-style: solid;
  border-width: 2px 0 0;
  clear: both;
  margin: 0 0 0px;
  height: 0;
}

.payment-thermal-document,
.payment-thermal-document table,
.payment-thermal-document [style*="font-size"] {
  font-size: 8.5pt !important;
  line-height: 1.28 !important;
}

.payment-thermal-document .my-2 {
  margin-top: 0.35rem !important;
  margin-bottom: 0.35rem !important;
}

.payment-thermal-document .py-1 {
  padding-top: 0.12rem !important;
  padding-bottom: 0.12rem !important;
}

.payment-thermal-document .card-body {
  padding: 10px !important;
}

.thermal-line-item {
  margin-bottom: 7px;
  padding-right: 0 !important;
  padding-left: 0 !important;
}

.thermal-items {
  width: 100%;
  margin-right: 0 !important;
  margin-left: 0 !important;
}

.thermal-line-item__name {
  display: block;
  overflow-wrap: anywhere;
  font-weight: 600;
  line-height: 1.3;
}

.thermal-line-item__calculation {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  margin-top: 2px;
  padding: 0 4px;
  line-height: 1.3;
}

.thermal-line-item__calculation span:last-child {
  flex: 0 0 auto;
  text-align: right;
  white-space: nowrap;
}

.thermal-line-item__discount {
  margin-top: 2px;
  padding: 0 4px;
  text-align: right;
}

.thermal-divider {
  clear: both;
  width: 100%;
  margin: 8px 0 7px;
  border-top: 2px dashed #6f7783;
}

.thermal-notes {
  display: block;
  width: 100%;
  padding: 0 2px;
  font-size: 8pt;
  line-height: 1.35;
  overflow-wrap: anywhere;
  white-space: normal;
}

.thermal-notes strong,
.thermal-notes span {
  display: block;
}

.thermal-notes span {
  margin-top: 3px;
}

.thermal-summary {
  display: block;
  width: 100%;
}

.thermal-summary table {
  width: 100%;
  table-layout: fixed;
}
.thermal-status {
  display: inline-block;
  margin-top: 7px;
  padding: 3px 7px;
  border: 1.5px solid currentColor;
  border-radius: 4px;
  font-size: 8pt;
  font-weight: 900;
  letter-spacing: 0.04em;
}
.thermal-copy {
  margin-top: 3px;
  font-size: 7.5pt;
  font-weight: 900;
}
.tone-success {
  color: #138451;
}
.tone-warning {
  color: #a96200;
}
.tone-danger {
  color: #c8323a;
}
.tone-info {
  color: #126b8c;
}
.tone-neutral {
  color: #5d6c80;
}
.thermal-footer-meta {
  margin-top: 9px;
  padding-top: 6px;
  border-top: 1px dashed #777;
  text-align: center;
  font-size: 7pt;
  line-height: 1.35;
  overflow-wrap: anywhere;
}
</style>
